import { funcModal } from 'components/modals'
import confirmExtendReservationModal from 'components/modals/confirmExtendReservationModal'
import moment from 'moment'

const components = {
    funcModal,
    confirmExtendReservationModal
}

const methods = {
    open (reservation, amount, diff_hours, timezone, currency_code, actionType = 'check-out') {
        this.type = "without_charge";
        this.reservation = reservation;
        this.amount = amount;
        this.diff_hours = diff_hours;
        this.currency_code = currency_code;
        this.actionType = actionType;
        this.currentTime = moment(moment(), ['YYYY-MM-DD HH:mm:ss']).tz(timezone).format('MM/DD/YYYY hh:mm A');
        this.$refs.modal.open();
    },

    onClose () {
        this.$emit('close');
    },

    updateProcessing(processing) {
        this.$emit("update-processing", processing);
        this.checkout_processing = processing;
    },

    updateReservation(type, item) {
        this.$emit('update-reservation', type, item);
        this.$refs.modal.close();
    },

    submit () {
        if (this.type == 'without_charge' || this.amount <= 0) {
            this.$emit("update-processing", true);
            this.$emit('update-reservation', this.type, this.reservation);
            this.$refs.modal.close();
        } else {
            this.$refs.confirmExtendReservationModal.open(this.reservation, this.amount, this.currency_code, this.actionType);
        }
    },
}

const computed = {
    modalTitle () {
        return this.actionType === 'check-in' ? 'Early Check-in Detected' : 'Late Checkout Detected';
    },

    modalDescription () {
        if (this.actionType === 'check-in') {
            return `This reservation starts in ${this.diff_hours} hours. Would you like to update their check-in time?`;
        }
        return `This reservation was scheduled to check out ${this.diff_hours} hours ago. Would you like to update their checkout time?`;
    },

    updateLabel () {
        return this.actionType === 'check-in' ? 'Yes, update check-in' : 'Yes, update checkout';
    },

    skipUpdateLabel () {
        return this.actionType === 'check-in' ? 'Do not update check-in time' : 'Do not update checkout time';
    }
}

export default {
    name: 'extend-reservation-modal',
    props: ['processing'],
    methods,
    computed,
    components,
    data () {
        return {
            reservation: null,
            amount: 0,
            diff_hours: 0,
            type: "without_charge",
            currentTime: null,
            checkout_processing: false,
            actionType: 'check-out',
        }
    }
}